<template>
  <template-page></template-page>
</template>
<script lang="ts">
import templatePage from '@/app-template/lib/pages/NotificationListPage.vue';
export default {
  components: { templatePage },
};
</script>
